import { render, staticRenderFns } from "./DrawSignature.vue?vue&type=template&id=5bc7a73b&scoped=true&"
import script from "./DrawSignature.vue?vue&type=script&lang=js&"
export * from "./DrawSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7a73b",
  null
  
)

export default component.exports